const triggerImageAnchorFoundSchema = [
  {
    type: 'checkbox',
    name: 'show_instructions',
    label: 'Show Instructions',
    help: 'If checked, the instructions will be shown when the image anchor is found.',
    events: ['input'],
  },
  {
    type: 'text',
    name: 'instructions_text',
    label: 'Instructions Text',
    events: ['input'],
  }
]

const triggerImageAnchorFoundValue = {
  show_instructions: true,
  instructions_text: 'Point your phone at this image',
}

export { triggerImageAnchorFoundSchema, triggerImageAnchorFoundValue }
